// removed by extract-text-webpack-plugin
module.exports = {"alternate-email":"AlternateEmail__alternate-email___34-H1"};